import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicContentVm } from '../operator-elearning-topic-content-vm.model';
import { IOperatorElearningTopicContentIm } from '../operator-elearning-topic-content-im.model';
import { IOperatorElearningTopicContentUm } from '../operator-elearning-topic-content-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicContentService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicContent`;
  }
  get(id: number): Observable<IOperatorElearningTopicContentVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.get<IOperatorElearningTopicContentVm>(this.baseUrl, { headers, params });
  }
  post(operatorElearningTopicContentIm: IOperatorElearningTopicContentIm): Observable<IOperatorElearningTopicContentVm> {
    const headers = this.createHeaders();
    return this.http.post<IOperatorElearningTopicContentVm>(this.baseUrl, operatorElearningTopicContentIm, { headers });
  }
  put(operatorElearningTopicContentUm: IOperatorElearningTopicContentUm): Observable<IOperatorElearningTopicContentVm> {
    const headers = this.createHeaders();
    return this.http.put<IOperatorElearningTopicContentVm>(this.baseUrl, operatorElearningTopicContentUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
